import { useFabricContext } from '@idmc-ms-fabric/integration';
import { FC } from 'react';
import { Route, Router, Switch } from 'react-router-dom';

import { devMode } from '../utils/coreUtils';
import DataSource from './data-source/DataSource';
import DevOnly from './DevOnly';
import IDQADetailsPage from './idqa-details/IDQADetails';
import ROUTES from './Routes';
import UtilitiesPage from './UtilitiesPage';

const AppRouter: FC = () => {
	const { history } = useFabricContext();
	return (
		<Router history={history}>
			<Switch>
				<Route path={ROUTES.dataQuality}>
					<IDQADetailsPage />
				</Route>
				<Route path={ROUTES.dataSource}>
					<DataSource />
				</Route>
				{devMode && (
					<Route path={ROUTES.utilities}>
						<UtilitiesPage />
					</Route>
				)}
				{devMode && (
					<Route path={ROUTES.dev_only}>
						<DevOnly />
					</Route>
				)}
			</Switch>
		</Router>
	);
};

export default AppRouter;
